import 'assets/styles/Report.css';

const ReportHeader = () => {
  return (
    <div className="report-header"></div>
  );
};

export default ReportHeader;